import React from 'react';
import { StyledBreadcrumb } from './styles';

const sections = [
  { key: 'Painel de Controle', content: 'Painel de Controle', href: '/admin/' },
  { key: 'Eventos', content: 'Eventos', href: '/admin/eventos' },
  { key: 'Criar', content: 'Criar', active: true }
]

const Back = () => {
  return (
    <StyledBreadcrumb icon='right angle' sections={sections} />
  );
}

export default Back;